import React from 'react';
import * as Yup from 'yup';
import { withFormik } from 'formik';
import styled from 'styled-components';
import { Link } from 'gatsby';

import { InputGroup, TextArea, Button, Heading, Subtitle } from '../elements';

const FormBoxWrapper = styled.form`
  background-color: ${(props) => props.theme.darkShades} !important;
  border-radius: 0 !important;
  padding: 3rem !important;
  @media screen and (max-width: 768px) {
    padding: 1em !important;
  }
  .is-size-6 {
    line-height: 24px;
  }
`;

const HeaderContent = ({ title, description }) => {
  return (
    <div className="columns is-variable is-7">
      {title && (
        <div className="column is-5">
          <Heading className="title is-3 mb-5  has-text-white">{title}</Heading>
        </div>
      )}
      {description && (
        <div className="column is-7">
          <Subtitle className="mb-5">{description}</Subtitle>
        </div>
      )}
    </div>
  );
};

const ContactForm = ({
  values,
  touched,
  errors,
  handleSubmit,
  handleChange,
  handleBlur,
  isSubmitting,
  title,
  description,
}) => {
  return (
    <FormBoxWrapper className="box" onSubmit={handleSubmit}>
      <HeaderContent title={title} description={description} />
      <div className="columns is-variable is-7">
        <div className="column is-5">
          <InputGroup
            label="Name"
            name="name"
            placeholder="Enter your full name"
            type="text"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.name && touched.name ? errors.name : undefined}
          />
          <InputGroup
            name="email"
            placeholder="Enter your email address"
            label="Email"
            type="text"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.email && touched.email ? errors.email : undefined}
          />
          <InputGroup
            label="Phone number"
            placeholder="Enter your contact phone number"
            name="telephone"
            type="text"
            value={values.telephone}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={
              errors.telephone && touched.telephone
                ? errors.telephone
                : undefined
            }
          />
          <InputGroup
            label="Company"
            placeholder="Enter your company name"
            name="company"
            type="text"
            value={values.company}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={
              errors.company && touched.company ? errors.company : undefined
            }
          />
        </div>
        <div className="column is-7">
          <TextArea
            rows={12}
            label="Message"
            placeholder="Enter details about your enquiry here"
            name="message"
            type="text"
            value={values.message}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={
              errors.message && touched.message ? errors.message : undefined
            }
          />
        </div>
      </div>
      <div className="is-size-6 has-text-white pb-3">
        By signing up you thereby agree to our contact{' '}
        <Link className="has-text-orange" to="/terms-and-conditions/">
          terms and conditions.
        </Link>
      </div>
      <Button
        disabled={isSubmitting}
        type="submit"
        className={`button is-dark is-fullwidth has-text-white ${
          isSubmitting && 'is-loading'
        }`}
      >
        SEND
      </Button>
    </FormBoxWrapper>
  );
};

export default withFormik({
  mapPropsToValues: () => ({
    name: '',
    company: '',
    email: '',
    message: '',
    telephone: '',
  }),
  validationSchema: Yup.object().shape({
    name: Yup.string().required('Name is required!'),
    telephone: Yup.string().required('Telephone is required!'),
    company: Yup.string().required('Company Name is required!'),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required!'),
    message: Yup.string(),
  }),
  handleSubmit: (values, { setSubmitting, resetForm, props }) => {
    props
      .onSubmit({ ...values })
      .then(() => {
        setSubmitting(false);
        resetForm();
      })
      .catch(() => {
        setSubmitting(false);
      });
  },
  displayName: 'ContactForm', // helps with React DevTools
})(ContactForm);
